import { INiche } from "services/types";

export interface CheckboxOption {
  label: string;
  name: string;
  value: string;
  isChecked: boolean;
  disabled: boolean;
  added?: boolean;
  available?: boolean;
}

const getDefaultOptions = (niche: INiche) => ({
  label: niche.name,
  name: niche.id,
  value: niche.id,
  available: niche?.available
});

export const nicheToOption = (niche: INiche): CheckboxOption => ({
  ...getDefaultOptions(niche),
  isChecked: false,
  disabled: false,
});

export const nicheToCheckedOption = (niche: INiche): CheckboxOption => ({
  ...getDefaultOptions(niche),
  isChecked: true,
  disabled: true,
});

export const compareOptions = (a: CheckboxOption, b: CheckboxOption) => {
  if (b.disabled && b.isChecked) {
    return 1;
  }
  if (a.isChecked && !b.isChecked) {
    return -1;
  }
  if (!a.isChecked && b.isChecked) {
    return 1;
  }
  return a.name.localeCompare(b.name);
};

export const calculateNicheFields = (
  followingNiches: INiche[],
  gifNiches: INiche[]
): CheckboxOption[] => {
  const followingNichesIds = new Set(followingNiches.map(n => n.id));
  const sortedNicheFields = gifNiches.reduce<CheckboxOption[]>((acc, n) => {
    if (n.added) {
      acc.push(nicheToCheckedOption(n));
    } else if (followingNichesIds.has(n.id)) {
      acc.push(nicheToOption(n));
    }
    return acc;
  }, []).sort(compareOptions);

  return sortedNicheFields;
};
